import { TextButton } from '@creditornot/cb-button';
import { CaretRight } from '@creditornot/cb-icons';
import { cbSemanticCssVars, typographyCss } from '@creditornot/cb-ingredients';
import { Input } from '@creditornot/cb-input';
import styled, { css } from 'styled-components';

import { MENU_MOBILE_BREAKPOINT } from '../../constants';
import CategorySubheader from '../CategorySubheader';
import OfferHeader from '../OfferHeader';
import { OptionHeader } from '../OptionHeader';

export const Root = styled.div`
  height: 100%;
  display: flex;
`;

export const CollectionContainer = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const HeaderContainer = styled.div`
  width: 100%;
  min-height: 104px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  overflow: hidden;
  border-block-end: 1px solid ${cbSemanticCssVars.borderPrimary};
  @media (max-width: ${MENU_MOBILE_BREAKPOINT}px) {
    flex-direction: column;
    justify-content: center;
    align-items: initial;
    padding: 0 16px;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  overflow: hidden;
  user-select: text;
`;

export const Title = styled.div`
  ${typographyCss.Heading4()};
  color: ${cbSemanticCssVars.textPrimary};
  margin-block-end: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Description = styled.div`
  ${typographyCss.Body3()};
  color: ${cbSemanticCssVars.textPrimary};
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const HeaderLeft = styled.div`
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  align-items: center;
  margin-inline-end: 8px;
`;

export const HeaderRight = styled.div<{ hidden?: boolean }>`
  display: flex;
  align-items: center;
  gap: 16px;
  @media (max-width: ${MENU_MOBILE_BREAKPOINT}px) {
    gap: 8px;
  }

  ${({ hidden }) =>
    hidden &&
    css`
      display: none;
    `}
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const ListWrapper = styled.div`
  height: 100%;
  position: relative;
`;

export const ContentContainer = styled.div`
  min-width: 0;
`;

export const ItemRow = styled.div``;

export const AddButton = styled(TextButton).attrs({ variant: 'brand' })``;

export const StyledOfferHeader = styled(OfferHeader)<{ isDragging?: boolean }>`
  min-width: 550px;
  opacity: ${({ isDragging }) => (isDragging ? 0 : 1)};
  @media (max-width: ${MENU_MOBILE_BREAKPOINT}px) {
    min-width: 320px;
  }
`;

export const StyledCategorySubheader = styled(CategorySubheader)`
  border-block-end: 1px solid ${cbSemanticCssVars.borderPrimary};
  min-width: 550px;
  @media (max-width: ${MENU_MOBILE_BREAKPOINT}px) {
    min-width: 320px;
  }
`;

export const StyledOptionHeader = styled(OptionHeader)`
  border-block-end: 1px solid ${cbSemanticCssVars.borderPrimary};
  min-width: 550px;
  @media (max-width: ${MENU_MOBILE_BREAKPOINT}px) {
    min-width: 320px;
  }
`;

export const StyledInput = styled(Input)`
  min-width: 202px;
  @media (max-width: ${MENU_MOBILE_BREAKPOINT}px) {
    min-width: 160px;
  }
`;

export const StyledCaretRight = styled(CaretRight)`
  width: 14px;
  margin-inline-start: 16px;
  margin-inline-end: 16px;
  fill: ${cbSemanticCssVars.textPrimary};
`;

export const ThumbnailContainer = styled.div`
  margin-inline-end: 16px;

  @media (max-width: ${MENU_MOBILE_BREAKPOINT}px) {
    display: none;
  }
`;
